import React, { useState, useEffect, useContext, memo } from "react"
import styles from "./index.module.scss"
import intl from "react-intl-universal"
import { WestgardRulerItem } from "../WestgardRulerItem"
import { WestgardRulesContext } from "../../../../../contexts/Equipments"
import Select from "../../../../atoms/Select"
import RcmpLoading from "../../../../atoms/Loading"

export const WestgardRulesComponent = ({
  rules,
  setRules,
  setIsChanged,
  isRulesRequiredSigma,
  isSelectedSigma,
  bIsLoading
}) => {
  const [listRulesSelected, setListRulesSelected] = useState(rules)

  const { setListRulesSelectedUnique, isSigma, setIsSigma, dataConfigAnalyte } =
    useContext(WestgardRulesContext)

  const fnHandleChangeRuler = (e) => {
    setListRulesSelected((oldState) => [...oldState, e])
    setIsChanged(true)
  }

  useEffect(() => {
    let itensUnicos = {}

    listRulesSelected?.forEach((objeto) => {
      itensUnicos[objeto.eqpanltwgr_wgrdr_nid] = objeto
    })

    let resultadoArray = Object.values(itensUnicos)

    setListRulesSelectedUnique(
      resultadoArray.map((item) => ({
        eqpanltwgr_bstatus: item.eqpanltwgr_bstatus,
        eqpanltwgr_eaction: item.eqpanltwgr_eaction,
        eqpanltwgr_wgrdr_nid: item.eqpanltwgr_wgrdr_nid,
      })),
    )
  }, [listRulesSelected])

  const optionsSigma = [
    { value: "Manual", label: "Manual" },
    { value: "Sigma", label: "Sigma" },
  ]

  const setSigmaRules = () => {
    const sigmaRules = dataConfigAnalyte?.eqpanlt_sigma_rules
    if (!sigmaRules?.length) return;

    const sigmaSelectedRules = rules?.map(rule => {
      if (sigmaRules.includes(rule?.eqpanltwgr_wgrdr_cname)) {
        return {
          ...rule,
          eqpanltwgr_bstatus: true,
          eqpanltwgr_eaction: "R"
        }
      } else {
        return {
          ...rule,
          eqpanltwgr_bstatus: false,
        }
      }
    })

    setRules(sigmaSelectedRules)
  }

  return (
    <div className={styles.wrapperWestgardRules}>
      <div className={styles.containerTitle}>
        <h1 className={styles.title}>{intl.get("ciq.westgard_roles")}</h1>

        <div className={styles.containerSelect}>
          <Select
            className={styles.select}
            width="100%"
            options={optionsSigma}
            defaultValue={isSelectedSigma ? optionsSigma[1] : optionsSigma[0]}
            searchable={false}
            clearable={false}
            disabled={!isRulesRequiredSigma}
            onSelect={(itemSelected) => {
              if (itemSelected.value === "Sigma") {
                setIsSigma(true)
                setSigmaRules()
              } else {
                setIsSigma(false)
              }
            }}
          />
        </div>
      </div>

      {bIsLoading ? (
        <div className={styles.flex}>
          <RcmpLoading bShow={true} size={60} />
        </div>
      ) : (
        <div className={styles.gridRules}>
          {rules?.map((rule) => (
            <WestgardRulerItem
              isSigma={isSigma}
              key={rule.eqpanltwgr_wgrdr_nid}
              cruler={rule.eqpanltwgr_wgrdr_cname}
              id={rule.eqpanltwgr_wgrdr_nid}
              bstatus={rule.eqpanltwgr_bstatus}
              rule={rule}
              fnHandleChangeRuler={fnHandleChangeRuler}
              setListRulesSelected={setListRulesSelected}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export const WestgardRules = memo(WestgardRulesComponent)
